// src/components/SectionDivider.jsx
//
// A thin SVG curve that "draws itself" as you scroll into view.
// Sits between major landing sections to give them visible structure.
import { useRef } from 'react';
import { useInViewOnce } from '../hooks/useAnimations';

export default function SectionDivider({ variant = 'curve' }) {
  const [ref, inView] = useInViewOnce(0.3);

  // Variants:
  //   - 'curve'    : an elegant slight arc
  //   - 'line'     : a clean centred hairline with markers
  //   - 'pulse'    : a glowing centre dot with rays
  const path =
    variant === 'curve'
      ? 'M 20 30 Q 200 8 400 30 T 780 30'
      : 'M 20 30 L 780 30';

  return (
    <div
      ref={ref}
      className={`section-divider ${inView ? 'in-view' : ''}`}
      style={{
        width: '100%',
        maxWidth: 800,
        margin: '0 auto',
        padding: '40px 24px',
        display: 'flex',
        justifyContent: 'center',
      }}
      aria-hidden
    >
      <svg viewBox="0 0 800 60" style={{ width: '100%', height: 60, overflow: 'visible' }}>
        <defs>
          <linearGradient id={`sd-${variant}`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%"  stopColor="rgba(0,229,160,0)" />
            <stop offset="50%" stopColor="rgba(0,229,160,0.55)" />
            <stop offset="100%" stopColor="rgba(0,229,160,0)" />
          </linearGradient>
        </defs>
        <path
          d={path}
          fill="none"
          stroke={`url(#sd-${variant})`}
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        {/* Markers */}
        <circle cx="400" cy={variant === 'curve' ? 17 : 30} r="2.5" fill="#00e5a0"
                opacity={inView ? 0.85 : 0}
                style={{ transition: 'opacity 0.8s cubic-bezier(0.16,1,0.3,1) 0.8s' }} />
        <circle cx="400" cy={variant === 'curve' ? 17 : 30} r="5.5" fill="none" stroke="#00e5a0"
                opacity={inView ? 0.3 : 0}
                style={{ transition: 'opacity 0.8s cubic-bezier(0.16,1,0.3,1) 0.9s' }} />
      </svg>
    </div>
  );
}
